import { gql } from "@apollo/client";

export const CREATE_IMAGE_LIBRARY = gql`
  mutation create_image_library($input: image_library_insert_input!) {
    insert_image_library_one(object: $input) {
      id
    }
  }
`;

export const UPDATE_IMAGE_LIBRARY = gql`
  mutation update_image_library($input: image_library_set_input, $where: image_library_bool_exp!) {
    update_image_library(_set: $input, where: $where) {
      returning {
        id
      }
    }
  }
`;

export const DELETE_IMAGE_LIBRARY = gql`
   mutation DeleteImageLibrary($id: Int!) {
    delete_image_library_by_pk(id: $id) {
      id
    }
  }
`;
